import React from "react";

interface Props {
  window: React.ReactNode;
}

export default function UserSupportToolWindowContainer({ window }: Props) {
  return <div className="w-[85%] p-6">{window}</div>;
}
